// extracted by mini-css-extract-plugin
export default {"submitBtn":"Button_submitBtn__h6r1r","ready":"Button_ready__LhRvA","wrong":"Button_wrong__6r1za","right":"Button_right__QnewL"};